import { BaseService } from './base.service';
import { HealthSummaryDto } from '@/types/health-summary';

class HealthSummaryService extends BaseService {
  constructor() {
    super('/health-summary');
  }

  async generate(memberId: string) {
    return await this.post(`/${memberId}`);
  }

  async getByMember(memberId: string): Promise<HealthSummaryDto[]> {
    const res = await this.get<{ data: HealthSummaryDto[] }>(`/member/${memberId}`);
    return res.data;
  }

  async downloadHealthSummaryPdf(memberId: string): Promise<Blob> {
    // GET /health-summary/:memberId/pdf
    return this.get(`/${memberId}/pdf`, { responseType: 'blob' });
  }

  async generateHealthSummaryPdf(memberId: string, selectedSections: string[], selectedTimelineItems?: string[]): Promise<{ success: boolean; message: string; pdfUrl: string }> {
    // POST /health-summary/:memberId/generate-pdf
    return this.post(`/${memberId}/generate-pdf`, { selectedSections, selectedTimelineItems });
  }

}

export const healthSummaryService = new HealthSummaryService();
